import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MeetingEventComponent } from './meeting-event-list/meeting-event-list.component';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MeetingEventService {
  constructor(private dialog: MatDialog) {}

  openMeetingEventListDialog(
    contactId,
    currentUserId: Observable<string>,
    namespace: Observable<string>,
    parentNamespace: Observable<string>,
  ) {
    this.dialog.open(MeetingEventComponent, {
      panelClass: 'custom-dialog-container',
      width: '500px',
      data: {
        contactId: contactId,
        currentUserId: currentUserId,
        namespace: namespace,
        parentNamespace: parentNamespace,
      },
    });
  }
}
